import { createContext } from "react";
import { IAuthState, IAuthContext } from "../interfaces-and-types";

export const loggedOutAuthState: IAuthState = {
  isLoggedIn: false,

  // active account credentials
  api_key: null,
  user: null,

  // static settings
  userSettings: {
    showBalance: false,
    darkModeSetting: "auto",

    // referral settings
    hideReferralAdvert: false,

    // notification preferences
    allowNotifications: true,
    allowNewsletterEmailNotifications: true,
    allowNewsletterPushNotifications: true,
  },
};

export const AuthContext = createContext<IAuthContext>({
  ...loggedOutAuthState,
  signIn: () => {},
  signOut: () => {},
  // backupMainAccount: () => {},
  // switchToSubAccount: () => {},
  // switchToMainAccount: () => {},
  // clearMainAccountBackup: () => {},

  setAuthenticationState: () => {},
  setApiKey: () => {},
  setUser: () => {},
  setUserSettings: () => {},
});
